import React from 'react';
import { Navigate } from 'react-router-dom';
import IndustryPageTemplate from '../../components/SEO/IndustryPageTemplate';
import { IndustryPageSEO } from '../../components/SEO/IndustryPageSEO';
import { IndustryData } from '../../data/industries';

interface IndustryPageProps {
  industry?: IndustryData;
}

export default function IndustryPage({ industry }: IndustryPageProps) {
  if (!industry) {
    return <Navigate to="/industries" replace />;
  }
  
  return (
    <>
      <IndustryPageSEO 
        industry={industry.name}
        industrySlug={industry.slug}
        description={industry.seoMetadata.description}
        keywords={industry.seoMetadata.keywords}
      />
      <IndustryPageTemplate industry={industry} />
    </>
  );
}